module.exports = __webpack_public_path__ + "ceab5cbffe9d72a4b0e39f7927bb3fb5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/download.svg
// module id = 585
// module chunks = 16